import { FixbotCTA } from '@ifixit/fixbot/fixbot-cta';
import initializeComponent from 'Shared/react-initialize';

function FixbotCTACard({
   guideId,
   isTeardown,
   fixbotOrigin,
}: {
   guideId: number;
   isTeardown: boolean;
   fixbotOrigin: string;
}) {
   return (
      <div className={isTeardown ? 'mb-12' : 'max-md:mb-10'}>
         <FixbotCTA
            origin={fixbotOrigin}
            contentType="guide"
            contentId={guideId}
            analyticsCategory="Guide"
            translationNamespace={isTeardown ? 'FixbotCTATeardown' : 'FixbotCTAGuide'}
         />
      </div>
   );
}

initializeComponent('FixbotCTACard', FixbotCTACard);
